import React, { useEffect, useState, useContext } from "react";
import ReconversionEnergeticaControllerContextProvider, {ReconversionEnergeticaControllerContext} from "../../context/ReconversionEnergeticaControllerContextProvider";
import ClayTable from "@clayui/table";
import HeaderTable from "../../../../../common/components/HeaderTable";
import Loading from "../../../../../common/components/Loading";
import Pagination from "../../../../../common/components/Pagination";
import { splitArray } from "../../../../../common/utils/utilsFunc";
import { CGE } from "../../../../../common/components/CGE";
import arTitles from "../../../../../common/services/mock/title.json";
import { getPathName } from "../../../../../common/utils/utilsFunc";
import { any } from "prop-types";

function ReconversionEnergeticaController({ props, qtdRowPage }) {
    const [state] = useContext(ReconversionEnergeticaControllerContext);
    const [loading, setLoading] = useState(false);

    const [activePage, setActivePage] = useState(1);
    const [rowPage, setRowPageList] = useState(10);
    const [currentArray, setCurrentArray] = useState([]);
    const [auxArray, setAuxArray] = useState([]);
    const [newArrTitle, setNewArrTitle] = useState(null);

    let error = null;

    function setRowPage(nPage) {
        setActivePage(1);
        setRowPageList(Number(nPage));
    }

    useEffect(() => {
        setNewArrTitle(arTitles[getPathName()]?.map((item) => item.label));
    }, [getPathName()]);

    useEffect(() => {
        let arrayOfarrays = [];
        arrayOfarrays = splitArray(auxArray, rowPage);
        setCurrentArray(arrayOfarrays[activePage - 1]);
    },[activePage, auxArray, rowPage]);

    useEffect(() => {
        if (!state.dataTable) {
            setLoading(true);
        } else {
            const objResponse = state.dataTable;
            setLoading(false);

            if (objResponse?.data?.solicitudesRES?.length > 0) {
                objResponse.data.solicitudesRES.map((obj) => {
                    Object.keys(obj).map((index) => {
                        if(index === "fechaSolicitud" || index === "fechaDia" || index === "fechaModificacion"){
                            obj[index] = formatDate(new Date(obj[index]));
                        }
                    });
                });
                setAuxArray(objResponse.data.solicitudesRES);

            } else if (objResponse?.data?.solicitudesRES?.length === 0) {
                props.setGlobalAlert(
                    "No se encontraron registros",
                    "warning",
                    true,
                    "Advertencia"
                );
                setAuxArray([]);
            } else {
                props.setGlobalAlert(
                    "El servicio no está disponible actualmente, intente más tarde.",
                    "warning",
                    true,
                    "Advertencia"
                );
            }
        }
    }, [state.dataTable]);

    let propsTable = {
        fileName: props.title_reconversion_energetica,
        title: props.title_reconversion_energetica,
        auxArray: auxArray,
        arTitles: arTitles,
        disabled: auxArray?.length > 0 ? false : true,
        setActivePage: setActivePage,
        qtdRowPage: qtdRowPage,
        setRowPage: setRowPage,
        rowPage: rowPage,
        activePage: activePage,
        excelBtn: true,
        showPagination: false,
    }

    var panelFooter = (
        <>
            <div className="d-flex align-items-center justify-content-center flex-column-reverse pb-4">
                <Pagination
                    items={auxArray}
                    onChangePage={setActivePage}
                    qtdRowPage={qtdRowPage}
                    setRowPage={setRowPage}
                    pageSize={rowPage}
                    currentPg={activePage}
                />
            </div>
        </>
    );

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        //return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        return `${day}-${month}-${year}`;
    };

    return (
        <div>
            <CGE.Panel footerContent={panelFooter}>
                <HeaderTable props={propsTable} />
                <ClayTable
                    class="table table-striped table-autofit show-quick-actions-on-hover table-list table-nowrap tbody-valign-middle thead-valign-middle table-valign-middle"
                    id="table-to-xls"
                >
                    <ClayTable.Head>
                        <ClayTable.Row>
                            {newArrTitle?.map((title) => {
                                return (
                                    <ClayTable.Cell headingCell className="clientCell font-weight-bold">
                                        {title}
                                    </ClayTable.Cell>
                                );
                            })}
                        </ClayTable.Row>
                    </ClayTable.Head>
                    <ClayTable.Body>
                        {currentArray ? (
                            currentArray?.map((obj) => {
                                return (
                                    <ClayTable.Row className="tableRow">
                                        {Object.keys(obj).map((index) => {
                                            if(index !== "comunaId"){
                                                return (
                                                    <ClayTable.Cell
                                                        className=" txt-with-link clientCell-td table-cell-minw-150 table-cell-expand text-truncate"
                                                        title={index}
                                                    >
                                                        {obj[index]}
                                                    </ClayTable.Cell>
                                                );
                                            }
                                        })}
                                    </ClayTable.Row>
                                );
                            })
                        ) : (
                            <ClayTable.Row>
                                <ClayTable.Cell colspan={newArrTitle?.length} className="text-no-results  font-weight-bold" >
                                    {!loading}
                                </ClayTable.Cell>
                            </ClayTable.Row>
                        )}
                    </ClayTable.Body>
                </ClayTable>
                {loading && <Loading />}
            </CGE.Panel>
        </div>
    );
}

const ReconversionEnergeticaControllerWithProvider = ({ props, qtdRowPage }) => (
    <ReconversionEnergeticaControllerContextProvider>
        <ReconversionEnergeticaController props={props} qtdRowPage={qtdRowPage} />
    </ReconversionEnergeticaControllerContextProvider>
);

export default ReconversionEnergeticaControllerWithProvider;